import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
} from '@angular/core';

@Component({
  selector: 'lyceo-skeleton-text',
  imports: [],
  templateUrl: './skeleton-text.component.html',
  styleUrls: ['./skeleton-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.animated]': 'animated()',
  },
})
export class SkeletonTextComponent {
  public readonly animated: InputSignal<boolean> = input<boolean>(true);
}
